import { createStore } from 'zustand/vanilla'

export type UserType = {
  balance_stars: number
  allowsWriteToPm: boolean
  first_name: string
  id: number
  languageCode: string
  last_name: string
  username: string
  photo_url: string
  is_premium: boolean
}

export type GlobalState = {
  user: UserType | null
}

export type GlobalActions = {
  setUser: (user: any) => void
  reducingBalanceStars: (number: number) => void
}

export type GlobalStore = GlobalState & GlobalActions

export const defaultGlobalState: GlobalState = {
  user: null,
}

export const createGlobalStore = (initState: GlobalState = defaultGlobalState) => {
  return createStore<GlobalStore>((set: any) => ({
    ...initState,
    setUser: (user: any) => set(() => ({ user })),
    reducingBalanceStars: (number: number) =>
      set((state: any) => ({
        user: state.user ? { ...state.user, balance_stars: state.user.balance_stars - number } : null,
      })),
  }))
}
